export var VALIDATE_CONTACT = {
    validateContact: {
        form: {
            name: 'Nombre',
            prefix: 'Prefijo de país',
            phone: 'Teléfono',
            active: 'Activo',
            inactive: 'Inactivo',
            tooltip: 'Haz clic aquí y activa este teléfono',
        },
        modal: {
            title: 'Activación de WhatsApp',
            code: 'Ingresa el código enviado a WhatsApp de {{name}} en el número {{phone}}.',
            resend: 'Reenviar código en {{seconds}} seg.',
            resendNow: '¿No recibiste el código? Reenviar',
            acceptTerms: 'Al hacer click en “Continuar” aceptas que Rappi te contacte vía WhatsApp, telefóno o SMS con fines comerciales. Conoce los <b> <a>Términos y condiciones</a> </b> y la <b><c target="_blank">Política de Privacidad</c></b>.',
            errorValidate: 'El código no es válido',
            successValidate: 'Número de teléfono validado exitosamente',
        },
    },
};
